import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, Loader2 } from "lucide-react";
import { useFeatures } from "@/lib/features";

const normalizePlate = (p) => (p || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export function WarrantyAlert({ plate, dense = false }) {
  const { enabled } = useFeatures();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const normalized = normalizePlate(plate);
  useEffect(() => {
    if (!enabled("os.garantia") || normalized.length < 7) { setData(null); return; }
    const ctl = new AbortController();
    setLoading(true);
    api.get(`/vehicles/by-plate/${encodeURIComponent(plate)}/warranty`, { signal: ctl.signal })
      .then(({ data }) => setData(data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
    return () => ctl.abort();
  }, [normalized, plate, enabled]);
  if (!enabled("os.garantia") || normalized.length < 7) return null;
  if (loading) return (
    <div data-testid="warranty-alert-loading" className="rounded-xl border border-zinc-800 bg-zinc-950/50 p-3 text-xs text-zinc-500 inline-flex items-center gap-2">
      <Loader2 className="h-3.5 w-3.5 animate-spin" /> Verificando garantia…
    </div>
  );
  if (!data || data.items.length === 0) return null;
  return (
    <div data-testid="warranty-alert" className="rounded-xl border border-amber-800/60 bg-amber-950/20 p-3 md:p-4">
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className="h-5 w-5 text-amber-300" />
        <h3 className="font-display text-sm md:text-base font-bold uppercase text-amber-200">Peças/serviços ainda na garantia</h3>
      </div>
      <ul className="space-y-1 text-sm">
        {data.items.slice(0, dense ? 4 : 10).map((w, i) => (
          <li key={i} data-testid={`warranty-alert-item-${i}`} className="flex justify-between gap-2">
            <span className="text-zinc-200 truncate">{w.description} <span className="text-[11px] text-zinc-500">({w.kind})</span></span>
            <span className="text-amber-200 whitespace-nowrap text-xs">
              até {new Date(w.until + "T00:00:00").toLocaleDateString("pt-BR")} <span className="text-zinc-500">({w.days_left}d)</span>
            </span>
          </li>
        ))}
        {data.items.length > (dense ? 4 : 10) && (
          <li className="text-[11px] text-zinc-500">+ {data.items.length - (dense ? 4 : 10)} outros itens</li>
        )}
      </ul>
      <p className="text-[11px] text-zinc-500 mt-2">Aviso só informativo. A OS pode ser criada normalmente — considere usar o botão "Retrabalho" se for cobertura de garantia.</p>
    </div>
  );
}
